export default __webpack_public_path__ + "static/media/dialyysi-lightblue.f72bc57e.svg";